var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.noSet)?_c('div',{staticClass:"no-set"},[_vm._t("no-set")],2):_vm._l((_vm.order),function(name,key){return [(_vm.$slots[name])?_c('div',{key:key,class:name},[_vm._t(name)],2):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }